import dynamic from "next/dynamic";
import Link    from "next/link";

import { getBaseURL }    from "_common/utils";
import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import Icon              from "_components/atoms/icon";
import Image             from "_components/atoms/image";
import Render            from "_components/atoms/render";
import ConfirmModal      from "_components/molecules/confirmModal";
import useStyles         from "_styles/molecules/pinnedComment";

import DonationProductUrl from "./donationProductURL";

const BottomStickyButton = dynamic ( () => import ( "_components/molecules/bottomStickyButton" ) );

const getTagImg = ( tagType, isStreamer ) => {
	if ( !tagType )
		return;

	switch ( tagType ) {
		case "FAN_RANK_1":
			return "/icons/chatTags/fanRankOne.png";

		case "FAN_RANK_2":
			return "/icons/chatTags/fanRankTwo.png";

		case "FAN_RANK_3":
			return "/icons/chatTags/fanRankThree.png";

		case "TOP_DONOR":
			return "/icons/chatTags/topDonorTag.png";

		case "HOST":
			return "/icons/chatTags/hostTag.png";

		case "NEW_USER":
			return isStreamer && "/icons/chatTags/newUserTag.png";

			/* This is for Chat Moderators */
		case "BROADCAST_MODERATOR":
			return "/icons/chatTags/modTag.png";
	}
};

const component = props => {

	const {
		emotesList,
		isStreamer,
		isOwnProfile,
		pinnedCommentData,
		unPinComment,
		isModerator,
		toggleReadMore,
		isReadMore,
		isMobile
	} = props;

	const { classes } = useStyles ();

	return (
		<div id = "pinned-comment">

			<div style = { { backgroundImage: "linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff)" } }></div>

			<Render condition = { pinnedCommentData }>
				<BackgroundWrapper
					key       = { 50 }
					className = { classes.topContainer }
					type      = "secondary"
				>
					<RenderAvatar
						isOwnProfile      = { isOwnProfile }
						isStreamer        = { isStreamer }
						pinnedCommentData = { pinnedCommentData }
					/>

					<RenderNameComment
						emotesList        = { emotesList }
						isModerator       = { isModerator }
						isOwnProfile      = { isOwnProfile }
						isReadMore        = { isReadMore }
						isStreamer        = { isStreamer }
						pinnedCommentData = { pinnedCommentData }
						toggleReadMore    = { toggleReadMore }
						unPinComment      = { unPinComment }
					/>

				</BackgroundWrapper>
			</Render>

			<Render condition = { isMobile }>
				<BottomStickyButton
					from  = "pinnedComment"
					title = { "Open App to Chat" }
				/>
			</Render>

		</div>
	);
};

export default component;

const RenderAvatar = ( {
	isStreamer,
	isOwnProfile,
	pinnedCommentData
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	if ( isStreamer && !isOwnProfile ) {
		return (
			<Image
				alt       = ""
				className = { classes.avatar }
				src       = { pinnedCommentData.sportsFan.photo }
				type      = "xldpi"
			/>
		);
	}

	return (
		<Link
			href     = { `${ getBaseURL () }/profile/${ pinnedCommentData.sportsFan.id }` }
			prefetch = { false }
		>
			<Image
				alt       = ""
				className = { classes.avatar }
				src       = { pinnedCommentData.sportsFan.photo }
				type      = "xldpi"
			/>
		</Link>
	);
};

const RenderNameComment = ( {
	isOwnProfile,
	isStreamer,
	pinnedCommentData,
	isModerator,
	isReadMore,
	emotesList,
	unPinComment,
	toggleReadMore
} ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.nameContainer }>
			<div className = { classes.commentHeader }>
				<div className = { classes.userName }>
					<Render condition = { isStreamer && !isOwnProfile }>
						<span>
							{pinnedCommentData.sportsFan.name}
						</span>
					</Render>

					<Render condition = { !isStreamer || isOwnProfile }>
						<a
							className = { classes.profileLink }
							href      = { `${ getBaseURL () }/profile/${ pinnedCommentData.sportsFan.id }` }
							rel       = "noreferrer"
							target    = "_blank"
						>
							<span className = { classes.iconContainer }>
								{pinnedCommentData.sportsFan.name}

								<Render condition = { pinnedCommentData?.commentTags }>
									<span className = { classes.tagPosition }>
										{
											pinnedCommentData.commentTags.map ( ( val, index ) => {
												if ( !val )
													return null;

												return (
													<Image
														key       = { val.id + index }
														alt       = ""
														className = { classes.tags }
														src       = { getTagImg ( val ) }
														type      = "xldpi"
													/>
												);
											} )
										}
									</span>
								</Render>

								{/* { // case top donor as well as fan rank
										pinnedCommentData?.commentTags ? (
											<span className = { classes.tagPosition }>
												{
													pinnedCommentData.commentTags[1] && (
														<Image
															alt       = ""
															className = { classes.tags }
															src       = { getTagImg ( pinnedCommentData.commentTags[1] ) }
														/>
													)
												}
											</span>
										) : null
									} */}

								{pinnedCommentData.commentText && <span>&nbsp;:</span>}

							</span>
						</a>
					</Render>

					<DonationProductUrl
						emotesList        = { emotesList }
						isReadMore        = { isReadMore }
						pinnedCommentData = { pinnedCommentData }
						toggleReadMore    = { toggleReadMore }
					/>

				</div>

				<div className = { classes.showOptionsButton }>
					{
						isStreamer || isModerator ? (
							<ConfirmModal
								buttonComponent = { (
									<Icon sameInBothTheme
										className = { classes.svgIcon }
										name      = "newPin"
									>

									</Icon>
								) }
								dialogText      = "Do you want you want to unpin the comment?"
								performAction   = { () => unPinComment () }
							/>
						) : (
							<Icon sameInBothTheme
								className = { classes.svgIcon }
								name      = "newPin"
							>

							</Icon>
						)
					}

				</div>
			</div>
		</div>
	);
};
